module.exports = __webpack_public_path__ + "img/message-circle-third.d34c4621.svg";